export const ANIMATION = 'animation';
export const AUDIO = 'audio';
export const IMAGE = 'image';
export const TEXT = 'text';
export const VIDEO = 'video';
export const WATERMARK = 'watermark';

export const ALL = [ANIMATION, AUDIO, IMAGE, TEXT, VIDEO, WATERMARK];
